import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ItemMasterHelp from "../../../Helper/SystemmasterHelp";
import '../Ledger/Ledger.css';
import { TextField, Grid, Typography } from '@mui/material';
import ReportButton from "../../../Common/Buttons/ReportButton"
import { CgArrowTopRightR } from "react-icons/cg";

const StockBookDetail = () => {
  const today = new Date().toISOString().split("T")[0];

const [fromDate, setFromDate] = useState(today);
const [toDate, setToDate] = useState(today);
  const [itemCode, setItemCode] = useState("");
  const [item_Name, setItemName] = useState("");
  const [accoid, setAccoid] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  const AccountYear = sessionStorage.getItem('Accounting_Year');

  // useEffect(() => {
  //   const currentDate = new Date().toISOString().split("T")[0];
  //   setFromDate(currentDate);
  //   setToDate(currentDate);
  // }, [toDate]);

  const handleItemCode = (code, accoid, hsn, name) => {
    setItemCode(code);
    setItemName(name);
    setAccoid(accoid);
  };

  const handleStockBookReport = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };

  const handleStockBookMillwiseReport = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-report-millwise?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };


   const handleStockBookDetailReport = (e) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/stock-book-detail-report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&itemCode=${encodeURIComponent(itemCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };

  // const handleRetailDetailReport = (e) => {
  //   navigate(`/retail-stock-book-detail-report`, {
  //     state: { itemCode, fromDate, toDate, item_Name },
  //   });
  // };

  return (
    <>
      <Typography variant="h6" style={{ textAlign: 'center', fontWeight: 'bold', marginTop: "100px" }}>
        FNO Purchase And Sale Details Report
      </Typography>
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30vh",
      }}>
        <div >

          <form onSubmit={handleStockBookReport}>
            <Grid container spacing={1} mt={2}>
              <div className="debitCreditNote-row" style={{ marginTop: "5px" }}>
                <label htmlFor="item_code" className="label">
                  Item Code :
                </label>
                <div className="debitCreditNote-col">
                  <div className="debitCreditNote-form-group">
                    <ItemMasterHelp
                      onAcCodeClick={handleItemCode}
                      CategoryName={item_Name}
                      CategoryCode={itemCode}
                      SystemType="I"
                      name="item_code"
                      className="account-master-help"
                    />
                  </div>
                </div>
              </div>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="From Date"
                  type="date"
                   name = "fromDate"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="To Date"
                  type="date"
                  name = "toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                />
              </Grid>
            </Grid>

            <div className="CommonbuttonContainer" style={{ marginTop: "20px" }} >
              <ReportButton label=" Stock Book Report"
                 icon={CgArrowTopRightR}
                 onClick={handleStockBookReport}
                 loading={loading}
                disabled={""}
              />

                <ReportButton label=" Millwise Stock Report"
                 icon={CgArrowTopRightR}
                 onClick={handleStockBookMillwiseReport}
                 loading={loading}
                disabled={""}
              />

              <ReportButton label="Stock Book Detail"
                icon={CgArrowTopRightR}
                onClick={handleStockBookDetailReport}
                loading={""}
                disabled={""}
              />

              {/* <ReportButton label="Retail Detail Report"
                icon={CgArrowTopRightR}
                onClick={handleRetailDetailReport}
                loading={""}
                disabled={""}
              /> */}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default StockBookDetail;
